module.exports = {
    lan :  {
      logName:'用户名/邮箱/手机号',
      logPwd:'密码',
      logo: require('../assets/wap/whitelogo.png'),
      logoB: require('../assets/wap/zhlogo.png'),
      serTit:'精彩广告素材从此开始',
      imgTit:'图片',
      motion:'视频',
      adTop:'为广告人提供专业视觉素材',
      companyJs:'蓝牛仔影像（北京）有限公司成立于2006年，<br/>是拍摄中国原创广告素材的专业团队，<br/>为国内外广告公司和各大企业以及各类媒体，<br/>提供新鲜创意的广告视觉素材。',
	  
	  
      salekf:'客服热线',
      aboutjean:'关于蓝牛仔',
      wmail:'官网邮箱',
      copynote:'版权声明',
      system:'系统留言',
      wapend:'本网站与所有图片均由蓝牛仔影像（北京）有限公司与<br/>美国蓝牛仔影像公司授权发布侵权必究。（2006－2020）京ICP备12011872</p>',
      newline:'最新上线',
      newlineV:'最新上线',
      editorSelects:'热门专题',
      desktop:'电脑版',
      purworld:'<a class="fleft">国内知名原创广告素材品牌</a><a class="m20L m20R fleft">|</a><a class="fright">中国广告公司优选合作伙伴</a>',
      aboutUS : '联系我们',
      creaImg:'原创图片',
      creaVideo:'原创视频',
      creaVideo2:'创意视频',
      browallimg:'全部图片',
      browallvideo:'全部视频',
      bycateg:'分类搜索',
      editTj:'编辑推荐',
      logIn:'登录',
      regIn:'注册',
      plogIN:'请登录》',
      recently:'最近浏览',
      zhword :'EN',
      signyours:'登录您的账户',
      password:'密码',
      forgotpwd:'忘记密码？',
      creatnew:'立即注册',
      noAccount:'没有账户？',
      reguser:'用户名',
      newpwd:'设置密码',
      conpwd:'确认密码',
      mobtel:'手机号',
      vercode:'验证码',
      havAccount:'已经有账户？',
      entermail:'请输入邮箱',
      entercode:'输入验证码',
      senmail:'发送邮件',
      telcode:'领取验证码',
      mailcode:'领取验证码',
      userName:'姓名',
      gender:'性别',
      datebirth:'出生日期（年-月-日）',
      compy:'公司',
      indust:'行业',
      posit:'职位',
      coungj:'国家',
      countrys:'地区',
      phone:'电话',
      savecont:'保存并继续',
      errorPwd:'密码错误',
      email:'邮箱',
      gsName:'邮箱格式不正确',
      mailerror:'邮箱地址有误',
      dailesend:'发送验证码超过单日发送限制',
      shortYhm:'用户名太短',
      sucreg:'注册成功',
      viatel:'手机验证',
      viaemail:'邮箱验证',
      respwd:'修改密码',
      beMail:'邮箱已存在',
      codeerror:'验证码错误',
      pwdsign:'修改密码成功，直接登录。',
      pwdfail:'修改密码失败，请重试！',
      yourName:'姓名',
      phoneMail:'手机/邮箱',
      Message:'留言',
      send:'发送',
      leaveCon:'请填写下面的信息给我们留言，<br/>我们会尽快回复您！',
      abmiansd:'邮件已收到，我们会尽快回复您',
      // 详情页
      bh:'编号:',
      more:'查看更多信息 ',
      hid:'隐藏更多信息 ',
      sysser:"摄影师:",
      endlicen:"授权信息：有模特肖像权和所有物权",
      gjc:"关键词",
      copyright:"本图片版权属于©蓝牛仔影像（北京）有限公司所有",
      checkreadSize:"查看全部尺寸 ",
      hideSize:"隐藏高清尺寸 ",
      gm:"立刻购买",
      joinCarts:"加入购物车",
      similarImg:"相似图片",
      moreSim:"更多相似",
      moreshoot:"查看全套",
      similarVid:"相似视频",
      zjll:"最近浏览",
      checkread:"查看全部 ",
        //下载小样图小介面
        dcompimg:"下载无水印小样图" ,
        choseimgsize:"选择小样图大小",
        agreeterms:"我已阅读并同意",
        agreeterms1:"蓝牛仔小样图使用条款",
        downcomp:'下载小样图',
        compzysx:'请注意：蓝牛仔授予您使用小样图的权利，但仅以您进行内部评估从而确定是否须获取非小样图许可使用为唯一目的。',
        compzysx1:'了解更多',
        dcompimg1:'蓝牛仔小样图使用条款',
        xyttk:'蓝牛仔授予您使用小样图的权利，但仅以您进行内部评估从而确定是否须购买免版税图片许可或版权管理图片许可为唯一目的。除仅为进行内部评估使用以外，您不得以其他任何方式使用小样图。小样图许可使用有效期为六十（60 ）天，自小样图下载日起计算。在小样图许可有效期终止后，如果您未获得适当的与该图片相关的免版税图片许可或版权管理图片许可，您将不得复制、分发、出版、展示或以其他任何方式使用小样图。如果没有获得上述许可，在小样图有效期届满后，您必须销毁所有小样图及其拷贝。任何违规使用小样图的行为将被认定为是盗版行为，蓝牛仔将依法追究其法律责任。',
        secbtn:'确定',
        ts:'请选择大小',
        ts1:'请同意使用条款',
        down10Text:'请完善资料后',
        down10Text1:'申请升级',
  
        //搜索
        imges:' 张',
        tpimg:'张图片',
        tpvid:'条视频',
        pages:'页',
        lsfavo:'临时收藏夹',
        signOut:'退出',
       //编辑推荐页
        recom: "编辑推荐",
        //分类搜索页
        classify: "分类搜索",
        newline1: "最新上线",
        classifyKey:[
          {src:"https://static.lanniuzai.com/img/newIndex/genre1.jpg" , width:333, height:246, key:"家庭", keyword:"家庭"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre2.jpg" , width:384, height:249, key:"商务", keyword:"商务"},
          {src:require("../assets/comimg/genre3.jpg" ), width:265, height:249, key:"度假", keyword:"度假"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre6.jpg" , width:322, height:223, key:"购物", keyword:"购物"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre5.jpg" , width:493, height:223, key:"公路,无人", keyword:"公路"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre4.jpg" , width:187, height:250, key:"中国文化,无人", keyword:"文化"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre7.jpg" , width:366, height:223, key:"样板间", keyword:"家居"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre11.jpg" , width:345, height:279, key:"运动", keyword:"运动"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre9.jpg" , width:303, height:270, key:"美容", keyword:"美容"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre8.jpg" , width:405, height:270, key:"儿童,老人,中年人,商务,孕妇", keyword:"青春"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre10.jpg" , width:472, height:270, key:"工业", keyword:"工业"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre13.jpg" , width:339, height:280, key:"技术", keyword:"科技"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre14.jpg" , width:274, height:240, key:"养老", keyword:"养老"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre20.jpg" , width:500, height:265, key:"医疗", keyword:"医疗"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre12.jpg" , width:496, height:279, key:"童年", keyword:"童年"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre15.jpg" , width:287, height:240, key:"商务,团队", keyword:"团队"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre16.jpg" , width:432, height:240, key:"汽车", keyword:"儿童"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre17.jpg" , width:178, height:240, key:"温泉", keyword:"spa"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre18.jpg" , width:365, height:265, key:"市区,无人", keyword:"城市"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre19.jpg" , width:314, height:265, key:"旅游", keyword:"旅游"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre25.jpg" , width:439, height:275, key:"过年", keyword:"过年"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre24.jpg" , width:330, height:290, key:"小朋友,教育", keyword:"教育"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre21.jpg" , width:222, height:290, key:"时尚", keyword:"时尚"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre22.jpg" , width:428, height:290, key:"婴儿", keyword:"婴儿"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre27.jpg" , width:186, height:124, key:"美食,无人", keyword:"美食"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre26.jpg" , width:327, height:275, key:"一个人,肖像", keyword:"肖像"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre28.jpg" , width:167, height:251, key:"中医", keyword:"中医"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre31.jpg" , width:389, height:250, key:"情侣,两个人", keyword:"情侣"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre23.jpg" , width:190, height:290, key:"静物", keyword:"静物"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre29.jpg" , width:358, height:250, key:"旅行", keyword:"旅行"},
          {src:"https://static.lanniuzai.com/img/newIndex/genre32.jpg" , width:257, height:250, key:"插画", keyword:"插画"},
        ],
        classifykey1:['快递物流','酒店','装修搬家','大学生','音乐','健身','定制服务','茶艺','夜生活','白背景','风光','全家福','贵族','宠物','退休生活','小区','超市','厨房','孕妇','生日','结婚','减肥','中秋节','成功人士','会议','服务','应聘','创业','交通','金融','办公室','设计师','差旅','移动','销售','早上','傍晚','春','夏','秋','冬','海边','雪地','草坪','山','森林','沙漠','湖边','街头'],
  
        //提交订单
        myHome:'账户',
        cart:'购物车',
        orders:'订单',
        lightbox:'收藏夹',
        down:'下载',
        titPay:'请确定购买订单信息',
        creatImg:'创意图片',
        imgSize:'图片大小',
        dimens:'图片尺寸',
        spaceColor:'色彩空间',
        typeLicen:'授权类别',
        downSize:'存储大小',
        priceyj:'原价',
        pricetj:'特价',
        redpoint:'积分',      
        totalP:'实际支付',
        voucher:'代金券',
        coupons:'优惠券',
        points:'分',
        suborder:'提交订单',
        orderID:'订单号',
        todue:'应付金额',
        chospay:'请选择支付方式',
        prcCheck:'在线支付',
        paysh:'稍后支付',
        endUsers:'最终用户',
        adAgency:'广告公司',
        otherThird:'第三方',
        debitbalan:'余额',
        offs:'折',
        allOrder:'全部',
        opend:'待付款',
        completed:'已付款',
        refunded:'已取消',
        canceled:'已退款',
        completeds:'已完成',
        sureDel:'你确定要删除吗？',
        sureCancel:'你确定要取消吗？',
        upqx:'取消',
        qddel:'确定',
        numrmb:'(元)',
        numusd:'(美元)',
        recharg:'充值',
        //充值
        addcou1:'充值￥1000元赠送2张￥50元的代金券',
        addcou2:'充值￥2000元赠送2张￥150元的代金券',
        addcou3:'充值￥5000元赠送2张￥400元的代金券',
        addcou4:'充值￥10000元赠送2张￥900元的代金券',
        addcou5:'充值￥20000元赠送4张￥1000元的代金券',
        addcou1s:'充值$100赠送2张$5的代金券',
        addcou2s:'充值$200赠送2张$15的代金券',
        addcou3s:'充值$500赠送2张$40的代金券',
        addcou4s:'充值$1000赠送2张$90的代金券',
        addcou5s:'充值$2000赠送4张$100的代金券',
        addfundsLs:'立即充值',
        addfunds:'充值账户',
        currentBs:'当前余额',
        zhangs:'图片数量',
  
         //我的账户
        alerts:'客服通知',
        balance:'当前余额',
        rechaacunt:'立即充值',
        Points:'积分',
        Coupon:'代金券',
        coupones:'优惠券',
        compdown:'小样图下载记录',
        zhe:'折',
        date:'有效期',
        edit:'编辑',
        hT:'换图',
        WeChat:'微信',
        xg:'修改',
        jb:'解绑',
        xgyx:'修改邮箱',
        ysyx:'原始邮箱',
        bdxyx:'绑定新邮箱',
        yspass:'原始密码',
        qrnewpass:'确认新密码',
        xgsj:'修改手机号',
        yssj:'原始手机号',
        newsj:'新手机号',
        notvou:'充值即可获赠代金券!',
        notcou:'暂时没有优惠券!',
       
  
        //收藏夹
        newFolder:'新建收藏夹',
        bjFolder:'编辑收藏夹',
        mc:'名称',
        kh:'客户',
        bz:'备注',
        state:'选择状态',
        sm:'私密',
        kfx:'可分享',
        wxts1:'温馨提示：',
        ts2:'“私密”状态需要登录账户才可访问，',
        ts3:' “可分享”不登录也可访问，并可分享链接。',
        bc:'保存',
        qr:'确认',
        canl:'删掉收藏夹',
        //订单
        account:'账户',
        lightboxe:'收藏夹',
        mycart:'购物车',
        myorder:'订单',
        download:'下载',
    }
  }
  